import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LinksManagement = () => {
    const [links, setLinks] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({
        type: "",
        value: ""
    });

    const baseUrl = "https://api.glyphqai.com";

    const linkTypes = [
        { label: "Facebook", value: "facebook_url" },
        { label: "Twitter", value: "twitter_url" },
        { label: "Instagram", value: "instagram_url" },
        { label: "LinkedIn", value: "linkedin_url" },
        { label: "WhatsApp", value: "whatsapp_url" },
        { label: "Gmail", value: "gmail_url" },
    ];

    useEffect(() => {
        fetchLinks();
    }, []);

    const fetchLinks = () => {
        axios.get(`${baseUrl}/api/get-all-links`)
            .then(response => {
                if (response.data.status === 200) {
                    setLinks(response.data.socialLinks);
                }
            })
            .catch(error => console.error("Error fetching links:", error));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleOpenModal = (type, link = null) => {
        setModalType(type);
        setFormData({
            type: link ? link.type : "",
            value: link ? link.value : "",
            id: link ? link.id : null
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const isAddMode = modalType === "add";
        const apiUrl = isAddMode 
            ? `${baseUrl}/api/store-link` 
            : `${baseUrl}/api/update-link/${formData.id}`;

        axios({
            method: isAddMode ? "post" : "put",
            url: apiUrl,
            data: { type: formData.type, value: formData.value },
            headers: { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.data.status === 200) {
                    toast.success(isAddMode ? "Link added successfully!" : "Link updated successfully!");
                    fetchLinks();
                    handleCloseModal();
                } else {
                    toast.error("Error: " + response.data.message);
                }
            })
            .catch((error) => {
                console.error(`Error ${isAddMode ? "adding" : "updating"} link:`, error);
                toast.error("Operation failed. " + (error.response?.data?.message || "Unknown error"));
            });
    };

    const handleDelete = (id) => {
        axios.delete(`${baseUrl}/api/deletelinks/${id}`)
            .then(() => {
                setLinks(links.filter(link => link.id !== id));
                toast.success("Link deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting link:", error);
                toast.error("Failed to delete link.");
            });
    };

    return (
        <>
            <ToastContainer />
            <div className="container">
                <div className="my-3 mt-5 d-flex justify-content-between">
                    <h2 className="font-bold display-5">Social Links Management</h2>
                    <Button onClick={() => handleOpenModal("add")}>Add Link</Button>
                </div>

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Type</th>
                            <th>Link</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {links.map((link, index) => (
                            <tr key={link.id}>
                                <td>{index + 1}</td>
                                <td>{linkTypes.find(t => t.value === link.type)?.label || link.type}</td>
                                <td>{link.value ? <a href={link.value} target="_blank" rel="noopener noreferrer">{link.value}</a> : "N/A"}</td>
                                <td>
                                    <Button variant="warning" className="me-2" onClick={() => handleOpenModal("edit", link)}>Edit</Button>
                                    <Button variant="danger" onClick={() => handleDelete(link.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === "add" ? "Add Link" : "Edit Link"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Type</Form.Label>
                            <Form.Select name="type" value={formData.type} onChange={handleInputChange} required>
                                <option value="">Select Type</option>
                                {linkTypes.map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formValue" className="mt-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter link"
                                name="value"
                                value={formData.value}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Button type="submit" className="mt-3">{modalType === "add" ? "Add Link" : "Update Link"}</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </>
    );
};

export default LinksManagement;
